import { Component, Input } from '@angular/core';
import type { ThemePalette } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import type { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { SpinnerComponent } from '@core/components/ui-spinner/spinner.component';

@Component({
  selector: 'ui-custom-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatDialogModule, SpinnerComponent,],
  templateUrl: './custom-spinner.component.html',
  styleUrls: ['./custom-spinner.component.scss']
})
export class CustomSpinnerComponent {
  @Input() diameter = '80';
  @Input() spinnerButton = '';
  @Input() showImage = true;
  @Input() image = '../../../../../../assets/images/favicon.ico';
  @Input() color: ThemePalette = 'primary';

  @Input() mode: ProgressSpinnerMode = 'indeterminate';

  @Input() value = 0;
}
